'use client';
import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import Link from 'next/link';
import { Logo } from '../ui/svgs/logo';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/navigation';
import nProgress from 'nprogress';
import { CustomConnectButton } from '../wallet/CustomConnectButton';
import { DepositButton } from '../wallet/DepositButton';
import { WithdrawButton } from '../wallet/WithdrawButton';
export function QuantNav() {
  const pathname = usePathname();
  const locale = pathname.split('/')[1];

  const router = useRouter();

  return (
    <Box bg="bg.t0" py={2} px={10}>
      <Flex align="center" justify="space-between">
        <Flex align="center" gap={'40px'}>
          <Box cursor={'pointer'}>
            <Logo />
          </Box>
          <Flex gap={'24px'} align="center">
            <Link
              href={`/${locale}/ai-earn`}
              onClick={() => {
                nProgress.start();
              }}
            >
              <Text
                fontSize={'16px'}
                color={'text.t1'}
                fontWeight={600}
                whiteSpace={'nowrap'}
              >
                AI Earn
              </Text>
            </Link>
          </Flex>
        </Flex>
        <Stack direction="row" gap={3}>
          <DepositButton />
          <WithdrawButton />
          <CustomConnectButton />
        </Stack>
      </Flex>
    </Box>
  );
}
